<template>
<div>
    <div class="form-group">
    <label  for="categoria"><strong>CATEGORIA</strong></label>
        <select @change="$emit('update',categoryId,$event)" :disabled="!props.isActive" :required="props.required" id="category" name="category" class="form-control" v-model="categoryId">
        <optgroup v-for="(group, name,index) in items" :key="index" :label="name">
         <option v-if="props.optionBase" value="0"> -- TUTTE LE CATEGORIE -- </option>    
        <option v-for="(option,index) in group" :key="index" :value="option.value">
            {{ option.text  }}
        </option>
        </optgroup>
        </select> 
    </div>
</div>

</template>
<script>
import api                   from "@/api";
import {setCategory,sortCat} from '@/functions';   
import {mapGetters }   from 'vuex';

export default {
  props : ['props'] , 
  components: {},
  data() {
    return {

      categoryId             : 0,
      items                  : [],
      spinner                : false,
      saved_items            : []
           
    };
  },
  computed:
  {
      ...mapGetters(['company']) 
  },   
  watch: {
     
    props:
        {handler: function (val, oldVal) { 

            if(val.groupId == 0)
            {
                this.items = setCategory(this.saved_items)
            }    
            else
            {    
            let parent = this.saved_items.filter(item => item.parentId == null && item.categoryId == val.groupId )
            let children = this.saved_items.filter(item => item.parentId == val.groupId  )
            
            
            
            let arr = []
            parent.forEach(item=>
            {
                arr.push(item)
            }
            )
            children.forEach(item=>{
                arr.push(item)
            })
            
            this.items = setCategory(arr)
            }
           // console.log(this.items)

         },
            deep: true
        }
    
    
    
    },
  mounted: function() 
  {
      
  },
  created: function() 
  {
      this.getData()
  },
  methods: 
  { 
      
    setCategoryList(obj)
    {
        console.log(obj)
    },  
    async getData()
    {            
      

      let sp    = {'sp'       : 'spCategorySelect'}
      let data  = {'companyId':this.company.Id}
      let json  = Object.assign(data, sp);  

      await api.post(json).then(res => {
            if(res.status==200)
            {
                //console.log(res.data.recordsets[0])
                this.items       = setCategory(res.data.recordsets[0])  
                this.saved_items = res.data.recordsets[0]
                this.categoryId  = this.props.Id
                
            }
           else if(res.status==500)
           {
                console.log(res.data)

            } 
          else
            {
                console.log('Network Error.')                  
                 
            } 
      
      

          }).catch(err => {
              
              console.log(err.message)    

              
          }).finally(() => {
          this.spinner = false
        });

    

    },
  
    
    
  
}

}
</script>
<style scoped>

</style>